export const prefix = 'form/';

export const BLUR = `${prefix}BLUR`;
export const CANCEL = `${prefix}CANCEL`;
export const CHANGE = `${prefix}CHANGE`;
export const CLEAR_CANCEL = `${prefix}CLEAR_CANCEL`;
export const CLEAR_SUBMIT = `${prefix}CLEAR_SUBMIT`;
export const DESTROY = `${prefix}DESTROY`;
export const FOCUS = `${prefix}FOCUS`;
export const INITIALIZE = `${prefix}INITIALIZE`;
export const LOAD_DATA = `${prefix}LOAD_DATA`;
export const REGISTER_FIELD = `${prefix}REGISTER_FIELD`;
export const RESET = `${prefix}RESET`;
export const FORCE_RELOAD = `${prefix}FORCE_RELOAD`;
export const SET_SUBMIT_FAILED = `${prefix}SET_SUBMIT_FAILED`;
export const SET_SUBMIT_SUCCEEDED = `${prefix}SET_SUBMIT_SUCCEEDED`;
export const START_SUBMIT = `${prefix}START_SUBMIT`;
export const START_VALIDATION = `${prefix}START_VALIDATION`;
export const STOP_SUBMIT = `${prefix}STOP_SUBMIT`;
export const STOP_VALIDATION = `${prefix}STOP_VALIDATION`;
export const SUBMIT = `${prefix}SUBMIT`;
export const UNREGISTER_FIELD = `${prefix}UNREGISTER_FIELD`;
export const SET_ROW_INDEX = `${prefix}SET_ROW_INDEX`;
export const DELETE = `${prefix}DELETE`;
export const CLEAR_DELETE = `${prefix}CLEAR_DELETE`;
export const CUSTOM_VALIDATION = `${prefix}CUSTOM_VALIDATION`;
export const TEMPORARY_SAVE_SUCCEEDED = `${prefix}TEMPORARY_SAVE_SUCCEEDED`;
export const MERGE_CONFLICTS = `${prefix}MERGE_CONFLICTS`;
export const UPDATE_MUTATION_ID = `${prefix}UPDATE_MUTATION_ID`;
export const BUSY_ON_TEMPORARY = `${prefix}BUSY_ON_TEMPORARY`;
